"use client";

import { useEffect } from "react";

declare global {
    interface Window {
        google?: any;
        googleTranslateElementInit?: () => void;
    }
}

export default function GoogleTranslate() {
    useEffect(() => {
        const scriptId = "google-translate-script";

        if (!document.getElementById(scriptId)) {
            const script = document.createElement("script");
            script.id = scriptId;
            script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit&hl=en";
            //   script.src =
            // "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";

            script.async = true;
            document.body.appendChild(script);

            window.googleTranslateElementInit = () => {
                if (window.google && window.google.translate) {
                    new window.google.translate.TranslateElement(
                        {
                            pageLanguage: "en", // your default language
                            includedLanguages: "en,zh-CN", // ✅ Only English & Chinese
                            layout:
                                window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                        },
                        "google_translate_element"
                    );
                }
            };
        } else if (window.google && window.google.translate) {
            new window.google.translate.TranslateElement(
                { pageLanguage: "en" },
                "google_translate_element"
            );
        }
    }, []);

    return (
        <div
            id="google_translate_element"
            className="text-sm inline-block rounded-lg pb-1"
        ></div>
    );
}
